import { isEventKey } from "keycode";

const SELECTORS = {
  radio: ".js-search-form-radio",
  searchInput: ".js-search-form-input",
  error: ".js-search-form-error",
  errorIcon: ".js-search-form-error-icon",
};

const CLASSES = {
  focus: "focus",
  hidden: "hidden",
  checked: "checked",
};

class SearchForm {
  constructor(context) {
    this.context = context;
  }

  init() {
    this.radios = [...this.context.querySelectorAll(SELECTORS.radio)];
    this.radiosParent = this.radios.map((radio) => radio.parentNode);
    this.searchInput = this.context.querySelector(SELECTORS.searchInput);
    this.errorMessage = this.context.querySelector(SELECTORS.error);
    this.errorIcon = this.context.querySelector(SELECTORS.errorIcon);
    this.radioButtonSelected = this.radios[0].parentNode;
    this.radioButtonFocused = this.radios[0].parentNode;

    this.addListeners();
  }

  addListeners() {
    document.addEventListener("click", (e) => this.handleClickOutside(e));

    this.context.addEventListener("submit", (e) => {
      e.preventDefault();
      this.validateForm();

      // TODO: Integrate search service
    });

    this.context.addEventListener("click", ({ target }) => {
      const isRadioButton =
        this.radios.includes(target) || this.radiosParent.includes(target);
      const isActiveRadioButton =
        target === this.radioButtonSelected ||
        target === this.radioButtonSelected.parentNode;
      const isSearchInput = target === this.searchInput;

      if (isRadioButton && !isActiveRadioButton) {
        this.radioButtonFocused.classList.remove(CLASSES.focus);
        this.searchInput.classList.remove(CLASSES.focus);
      } else if (isSearchInput) {
        this.radioButtonFocused.classList.remove(CLASSES.focus);
      } else {
        this.searchInput.classList.remove(CLASSES.focus);
      }
    });

    this.context.addEventListener("keyup", (e) => {
      if (isEventKey(e, "tab")) {
        const { activeElement } = document;
        const isRadioButtonFocused = this.radios.includes(activeElement);
        const isTextInputFocused = activeElement === this.searchInput;

        if (isRadioButtonFocused) {
          const radioButtonParent = activeElement.parentNode;

          this.searchInput.classList.remove(CLASSES.focus);
          radioButtonParent.classList.add(CLASSES.focus);
          this.radioButtonFocused = radioButtonParent;
        } else if (isTextInputFocused) {
          this.radioButtonFocused.classList.remove(CLASSES.focus);
          this.searchInput.classList.add(CLASSES.focus);
        } else {
          this.radioButtonFocused.classList.remove(CLASSES.focus);
          this.searchInput.classList.remove(CLASSES.focus);
        }
      }
    });

    this.radios.forEach((radio) => {
      const radioButtonParent = radio.parentNode;

      radio.addEventListener("change", () => {
        if (radio.checked) {
          this.radioButtonSelected.classList.remove(CLASSES.checked);
          radioButtonParent.classList.add(CLASSES.checked);
          this.radioButtonSelected = radioButtonParent;
        }
      });

      radio.addEventListener("blur", () => {
        this.radioButtonSelected.classList.remove(CLASSES.focus);
      });

      radio.addEventListener("keyup", (e) => {
        const isArrowKey =
          isEventKey(e, "up") ||
          isEventKey(e, "right") ||
          isEventKey(e, "down") ||
          isEventKey(e, "left");

        if (isArrowKey) {
          const currentRadioButtonParent = e.currentTarget.parentNode;

          currentRadioButtonParent.classList.add(CLASSES.focus);
          this.radioButtonFocused.classList.remove(CLASSES.focus);
          this.radioButtonFocused = currentRadioButtonParent;
        }
      });
    });

    this.searchInput.addEventListener("input", () => {
      this.errorMessage.classList.add(CLASSES.hidden);
      this.errorIcon.classList.add(CLASSES.hidden);
    });
  }

  handleClickOutside({ target }) {
    const isClickInside = this.context.contains(target);

    if (!isClickInside) {
      this.searchInput.classList.remove(CLASSES.focus);
      this.radioButtonFocused.classList.remove(CLASSES.focus);
    }
  }

  validateForm() {
    if (this.searchInput.value === "") {
      this.errorMessage.classList.remove(CLASSES.hidden);
      this.errorIcon.classList.remove(CLASSES.hidden);
    }
  }
}

export { SearchForm };
